import api from './api';
import { API_COMMANDS } from './commands';

const getUserInfo = async () => {
  const response = await api.get('', {
    params: { command: API_COMMANDS.USER_INFO },
  });
  return response.data;
};

export default getUserInfo;
